import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { CSSTransition } from 'react-transition-group';
import { useQuery } from '@apollo/client';

import useInsuranceInfo from '../../../hooks/useInsuranceInfo';
import { getMenuLinksConfig } from '../navMenuUtils';
import {
  useSelectCustomer,
  GET_CUSTOMER,
  DA_DIREKT_POLICY_CATEGORIES,
  RISK_CARRIER_AMTRUST,
  SPECIAL_TARIFF_POLICY_CATEGORIES,
} from '../../../shared';
import { myProfileLinkItems, helpLinkItems } from '../navMenuConfig';

import NavLinkDropdown from './NavLinkDropdown';
import {
  StyledNavMenuDesktop,
  StyledNavMenuDesktopContainer,
  StyledNavMenuItemDesktopLink,
} from './NavMenuDesktop.styled';

function NavMenuDesktop() {
  const { data: customerData } = useQuery(GET_CUSTOMER);
  const customerInsuranceCategory = customerData?.customer?.insuranceCategory;
  const customerPolicyCategory = customerData?.customer?.contract?.policyCategory;
  const [ready, setReady] = useState(false);
  const location = useLocation();

  const intl = useIntl();

  const { type: insuranceType, isPatolo } = useInsuranceInfo();
  const isAmtrustCustomer = customerData?.customer?.contract?.riskCarrier === RISK_CARRIER_AMTRUST;

  const isDaDirektCustomer =
    Number.isInteger(customerPolicyCategory) &&
    DA_DIREKT_POLICY_CATEGORIES.includes(customerPolicyCategory);

  const isSpecialTariffCustomer =
    Number.isInteger(customerPolicyCategory) &&
    SPECIAL_TARIFF_POLICY_CATEGORIES.includes(customerPolicyCategory);

  const menuLinksConfig = getMenuLinksConfig(
    insuranceType,
    customerInsuranceCategory,
    isDaDirektCustomer,
    isAmtrustCustomer,
    isSpecialTariffCustomer,
    isPatolo
  );

  useEffect(() => {
    if (!ready) setReady(true);
  }, [ready]);

  if (useSelectCustomer(location?.pathname)) {
    return null;
  }

  return (
    <CSSTransition in={ready} timeout={400} classNames="nav-menu-desktop" unmountOnExit>
      <StyledNavMenuDesktop data-nav-menu-desktop>
        <StyledNavMenuDesktopContainer>
          <NavLinkDropdown
            caption={intl.formatMessage({ id: 'menu.header.item.my_profile' })}
            linkItems={myProfileLinkItems(intl)}
          />

          {menuLinksConfig.map((linkItem) =>
            linkItem?.externalUrl ? (
              <StyledNavMenuItemDesktopLink
                key={linkItem.link}
                variant="h3"
                href={linkItem.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkItem?.title}
              </StyledNavMenuItemDesktopLink>
            ) : (
              <StyledNavMenuItemDesktopLink
                key={linkItem.path}
                variant="h3"
                href={linkItem.path}
                isCurrentPage={linkItem.path === location.pathname}
              >
                {linkItem.title}
              </StyledNavMenuItemDesktopLink>
            )
          )}

          <NavLinkDropdown
            caption={intl.formatMessage({ id: 'menu.header.item.help' })}
            linkItems={helpLinkItems(intl, insuranceType, isPatolo)}
          />
        </StyledNavMenuDesktopContainer>
      </StyledNavMenuDesktop>
    </CSSTransition>
  );
}

export default NavMenuDesktop;
